module.exports = __webpack_public_path__ + "1ba4767ee37aab7e8d34fc339c3538cc.ttf";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Lato-BoldItalic.ttf
// module id = 713
// module chunks = 0